import { ArrowDownIcon } from 'lucide-react';

export const ScrollUntilComponent = () => (
  <div className='flex gap-2 items-end fixed bottom-8 right-14 py-2 px-4 bg-accent-main text-neutral-50 text-[14px] z-50 rounded-[50px]'>
    <ArrowDownIcon className='h-4 w-4' />
    more changes below
  </div>
);
